export default __webpack_public_path__ + "static/media/tramy_news_1.0077e03d.svg";